// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
export var backdropColors = function(mode) {
    var bg = background(mode);
    return {
        background: bg.modalOverlay
    };
};

//# sourceMappingURL=backdropColors.js.map